<template>
	<div class="">
		<!--头部-->
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>

		<div class="m-hxbk">
			<div class="hxbk_count">
				<!--三级导航 GO-->
				<div class="deputy_panel" v-if="curr==0">
					<div class="tabs_active " v-for="(item,index) in list" :key="index" v-if="index==0"
						@click="show_zb_list(index,type)">
					<!-- 	<span class="tabs_next">{{lang=='CN' ?item.cn_name:item.en_name}}22</span> -->
						<div v-if="index==0" class="panel_tabs_next" v-for="(ite,ind) in list[0].children"
							@click="xuanzhong(ite,index)" :class="jx_index==ite.id ? 'active' : ''">
							<span>{{lang=='CN' ?ite.cn_name:ite.en_name}}</span>
						</div>
					</div>
					<div class="deputy_panel_tabs pointer" v-if="index>0" v-for="(item,index) in list" :key="index">
						<span class="span">{{lang=='CN' ?item.cn_name:item.en_name}}</span>
						<div class="deputy_panel_tabs_next css3" v-for="(ite,ind) in item.children"
							@click="xuanzhong2(ite,index)" :class="jx_index==ite.id ? 'next_active' : ''">
							<span>{{lang=='CN' ?ite.cn_name:ite.en_name}}</span>
						</div>
					</div>
				</div>

				<!--沈绍安漆艺 GO-->
				<div v-if="jx_index==94">
					<BrandProject></BrandProject>
				</div>
				<!--东方大漆 GO-->
				<div v-if="jx_index==107">
					<CoreOrientalRacquer></CoreOrientalRacquer>
				</div>


				<!--栏目海报 GO-->
				<div class="wow fadeInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
					<img class="list_img" v-if="jx_index==6757" :src="zidiyiData.c1.files" />
					<img class="list_img" v-if="jx_index==25" :src="zidiyiData.c1.files" />
					<img class="list_img"
						v-if="jx_index==17 || jx_index==18 || jx_index==20 || jx_index==21|| jx_index==163 "
						:src="zidiyiData.c2.files" />
					<img class="list_img" v-if="jx_index==28 || jx_index==35 || jx_index==36 "
						:src="zidiyiData.center_part.files" />
					<img class="list_img" v-if="jx_index==22" :src="zidiyiData.video_banner.files" />
				</div>

				<!--艺品芸 GO-->
				<div class="m-yipinyun" v-if="jx_index==26">
					<div class="list_count">
						<div class="wow fadeInUp animated" data-wow-delay="0.5s">
							<img class="list_img" :src="zidiyiData.yipinyun_banner.files" />
						</div>
						<div class="wrap-y">
							<!-- 艺品芸介绍 GO-->
							<div class="yipinyun-dec">
								<div class="tit">
									<div class="logo">
										<img src="@/assets/img/yipin-logo.jpg">
									</div>
									<!--通用标题 GO-->
									<div class="info_tit">
										<div class="tit_left">
											<span>艺品芸简介</span>
											<el-divider direction="vertical"></el-divider>
											<span>INTRODUCE</span>
										</div>
									</div>
								</div>
								<div class="cont">
									<div class="txt"
										v-html="lang=='CN' ?zidiyiDataDes.yipinyun_dec.cn_content:zidiyiDataDes.yipinyun_dec.en_content">
									</div>
									<div class="qrcode">
										<img :src="zidiyiData.yipinyun_qrcode.files" />
										<div class="tip">
											{{lang=='CN' ? '扫码进入公众号' : 'scan on wechat'}}
										</div>
									</div>
								</div>
							</div>
							<!-- 艺品云空间 GO-->
							<div class="sub-banner">
								<div class="pic"><img class="css3" :src="zidiyiData.yipinyun_spacebanner.files" /></div>
								<ul class="items">
									<li class="item" v-for="(item,index) in artOneList"
										@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
										<span>{{lang=='CN' ? item.cn_title : item.en_title}}</span>
										<img src="@/assets/img/youjian.png">
									</li>
								</ul>
							</div>
							<!-- 展览展示 GO -->
							<div class="exhibition-container">
								<div class="list_info">
									<div class="info_tit">
										<div class="tit_left">
											<span>展览展示</span>
											<el-divider direction="vertical"></el-divider>
											<span>EXHIBITION</span>
										</div>
										<div class="tit_right f14" @click="go_list(39)">
											<span>查看更多</span>
											<el-divider direction="vertical"></el-divider>
											<span>MORE</span>
										</div>
									</div>
									<div class="cont-left">
										<el-carousel indicator-position="none" height="600px" :interval="5000">

											<el-carousel-item v-for="(item,index) in 5" :key="index">
												<el-image @click="go_open()" class="pic img-responsive"
													:src="zidiyiData.yipinyun_exhibition.files" alt="佳信官方主页"></el-image>
											</el-carousel-item>
										</el-carousel>
									</div>
									<ul class="cont-right">
										<li v-for="(item,index) in artTwoList" v-if="index<3"
											@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
											<div class="tit">{{lang=='CN' ? item.cn_title : item.en_title}}</div>
											<div class="time">{{item.publishtime_text}}</div>
											<div class="txt">{{lang=='CN' ?item.cn_cont:item.en_cont}}</div>

										</li>
									</ul>
								</div>
							</div>

							<!-- 艺术私塾 GO-->
							<div class="pro-school">
								<div class="info_tit">
									<div class="tit_left">
										<span>艺术私塾 </span>
										<el-divider direction="vertical"></el-divider>
										<span>ART SCHOOL</span>
									</div>
								</div>
								<div class="row" v-if="true">
									<div class="pro_school">
										<div class="school_left">
											<el-collapse v-model="activeName" accordion @change="handleChange">
												<el-collapse-item :title="lang=='CN' ?item.cn_name:item.en_name"
													:name="index" v-for="(item,index) in shoolList">
													<img :src="item.image_text"
														@click="handleChange(index);go_list(item.id);">
													<div class="title" @click="go_list(item.id)">{{item.seo1}}</div>
												</el-collapse-item>
											</el-collapse>
										</div>
										<div class="school_right">
											<div class="right_header">
												<div class="info_tit">
													<div class="tit_left">
														<span>艺术大家</span>
													</div>
													<div class="tit_right f14" @click="go_list(149)">
														<span>查看更多</span>
														<el-divider direction="vertical"
															style="background-color: #000000;"></el-divider>
														<span>MORE</span>
													</div>
												</div>
											</div>
											<div class="right_list css3" v-for="(item,index) in artistTList"
												v-if="index<3"
												@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
												<div class="info_left">
													<img class="css3" :src="item.image" />
												</div>
												<div class="info_right">
													<div class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}
													</div>
													<div class="right_down">
														{{item.publishtime_text}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									暂无数据~
								</div>
							</div>
							<!-- 艺术沙龙 GO-->
							<div class="pro-salon">
								<div class="info_tit">
									<div class="tit_left">
										<span>艺术沙龙 </span>
										<el-divider direction="vertical"></el-divider>
										<span>ART SALON</span>
									</div>
									<div class="tit_right f14" @click="go_list(150)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="salon_content">
									<div class="item" v-for="(item,index) in salonList" v-if="index<4"
										@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
										<div class="pic">
											<img :src="item.image" />
										</div>
										<div class="bottom">
											<div class="title line-1">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
											<div class="icom_f">
												<img src="@/assets/news/right.png" />
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 艺品芸商城 GO-->
							<div class="pro-container ">
								<div class="info_tit">
									<div class="tit_left">
										<span>艺术商城 </span>
										<el-divider direction="vertical"></el-divider>
										<span>SHOPPING MALL</span>
									</div>
									<div class="tit_right f14" @click="goShop(6)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="row" v-if="proList.length>0">
									<div class="item  " v-for="(item,index) in proList">
										<a :href="item.outlink" target="_blank">
											<div class="photos">
												<img class="photo" :src="item.image" />
												<div class="ewm css3">
													<img :src="item.ewm" />
													<div class="tips">
														{{lang=='CN' ?'扫码了解商品详情':'Find out details'}}
													</div>
												</div>
												<div class="mask css3"></div>
											</div>
											<div class="info">
												<div class="title line-2">{{lang=='CN' ? item.title: item.en_title}}
												</div>
												<div class="time">{{lang=='CN' ? '制作时间/年份': 'createTime/Year:'}}
													{{item.createtime_text}}
												</div>
											</div>
										</a>
									</div>
								</div>
								<div class="row" v-else>
									暂无数据~
								</div>
							</div>
							<!-- 艺品芸资讯 GO-->
							<div class="m-newList list_info">
								<div class="info_tit">
									<div class="tit_left">
										<span>艺品资讯</span>
										<el-divider direction="vertical"></el-divider>
										<span>REAL-TIME INFO</span>
									</div>
									<div class="tit_right f14" @click="go_list(128)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="liebiao_list wow fadeInUp animated">
									<div class="wow fadeInUp animated">
										<div class="liebiao_info css3" v-for="(item,index) in artThreeList">
											<div class="info_left col-xs-12 col-lg-3">
												<div class="border-hover css3"></div>
												<img class="css3" :src="item.image" />
											</div>
											<div class="info_right col-xs-12 col-lg-9"
												@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
												<span
													class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
												<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
												<div class="right_down">
													<span>{{item.publishtime_text}}</span>
													<div class="right_down_div">
														<span class="commo_span">
															<img class="eye" src="@/assets/news/eye.svg" />
															<span>{{item.view}}</span>
														</span>
														<span class="commo_span">
															<img src="@/assets/news/comment.svg" />
															<span>{{item.comment_num}}</span>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 艺术品收藏 GO-->
							<div class="pro-container ">
								<div class="info_tit">
									<div class="tit_left">
										<span>艺术品收藏 </span>
										<el-divider direction="vertical"></el-divider>
										<span>COLLECTION</span>
									</div>
									<div class="tit_right f14" @click="go_list(82)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="row" v-if="artFourList.length>0">
									<div class="item  " v-for="(item,index) in artFourList"
										@click="(item.outlink=='' || item.outlink=='#')?go(item.id):go_open(item.outlink)">
										<div class="photos">
											<img class="photo" :src="item.image" />
										</div>
										<div class="info">
											<div class="title line-1">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
											<div class="time line-2">{{lang=='CN' ?item.cn_cont:item.en_cont}}</div>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									暂无数据~
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--大福湾 GO-->
				<div class="m-dafuwan" v-if="jx_index==27">
					<div class="list_count">
						<div class="wow fadeInUp animated" data-wow-delay="0.5s">
							<img class="list_img" :src="zidiyiData.dafuwan_banner.files" />
						</div>
						<!--大福湾简介 GO-->
						<div class="introduce-fw">
							<div class="common_tit wow fadeInUp animated">
								<div class="tit_left">
									<span>大福湾介绍</span>
									<el-divider direction="vertical"></el-divider>
									<span>ABOUT US</span>
								</div>
								<div class="logo" @click="go_list2">
									<image src="@/assets/img/logo_dafuwan.png"></image>
								</div>
							</div>
							<div class="about"
								v-html="lang=='CN' ?zidiyiDataDes.dafuwan_about.cn_content:zidiyiDataDes.dafuwan_about.en_content">
							</div>
						</div>
						<!--音频区块 GO-->
						<div class="m-audio">
							<img src="@/assets/img/audio.jpg" alt="">
							<div class="cont">
								<div class="tit">
									<span>{{lang=='CN' ?'福天福地大福湾 ':'Dafuwan'}}
									</span><span>{{lang=='CN' ?zidiyiData.audio.directions:'original the song of Dafuwan'}}</span>
									<span @click="go(199)">{{lang=='CN' ?'查看歌词':'View Lyric'}}</span>
								</div>
								<div class="wrap">
									<audio :src="zidiyiData.audio.files" controls='controls' preload="preload"
										autoplay="true" width="1240" height="100">
										当前浏览器不支持audio
									</audio>
								</div>
							</div>
						</div>
						<!-- 次级标题 GO-->
						<div class="sub_area">
							<div class="tit">{{zidiyiDataDes.dafiwan_title.cn_title}}</div>
							<div class="pic"><img class="css3" :src="zidiyiData.dafuwan_subbanner.files" /></div>
							<div class="bg"></div>
							<div class="more more_btn" @click="go(245)">
								<span>{{lang=='CN' ?'走进大福湾':'Find out details'}}</span>
								<img src="@/assets/img/youjian.png" />
							</div>
							<!-- 二维码定位 GO -->
							<div class="ggz_posi">
								<div><img class="logo" src="@/assets/img/logo_dafuwan.jpg" /></div>
								<div><img :src="zidiyiData.dafuwan_qrcode.files" style="width: 260px;" /></div>
								<div>{{lang=='CN' ? '扫码进入公众号' : 'scan on wechat'}}</div>
							</div>
						</div>
						<!-- 大福湾纪事 GO -->
						<div class="fuwan-list">
							<div class="list_info">
								<div class="info_tit">
									<div class="tit_left">
										<span>大福湾纪事 </span>
										<el-divider direction="vertical"></el-divider>
										<span>CHROMICLE</span>
									</div>
									<div class="tit_right f14" @click="go_list(76)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="dafuwan-list row">
									<div class="items col-xs-12 col-lg-4 pointer" v-for="(item,index) in fuwanList">
										<div class="hover_img">
											<img class="info_img css3" :src="item.image" />
										</div>
										<div class="info_tit">{{lang=='CN' ? item.cn_title : item.en_title}}</div>
										<div class="info_footer">
											<div class="info_footer_left">
												<div class="line1"></div>
												<span>{{item.publishtime_text}}</span>
											</div>
											<div class="info_footer_right"
												@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
												<div class="more">
													<span>{{lang=='CN' ?'了解详情':'Find out details'}}</span>
													<img src="@/assets/img/youjian.png" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 福湾印象 GO-->
							<div class="list_info">
								<div class="info_tit">
									<div class="tit_left">
										<span>大福湾印象 </span>
										<el-divider direction="vertical"></el-divider>
										<span>IMPRASSUION</span>
									</div>
									<div class="tit_right f14" @click="go_list2">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>

								<div class="impress"
									:style="categoryBgs?'background:url('+categoryBgs[categoryBgsIndex?categoryBgsIndex:3]+') center bottom no-repeat':''">
									<div class="thumbs css3">
										<div class="fuwantit" :class="fuactive==i.id?'active':''"
											v-for="(i,index) in categoryList" @click="getImpressList(i.id,index)"
											v-if="index>2 && index<7">
											{{i.cn_name}} {{i.en_name}}
										</div>
									</div>
									<div class="swiper-wrap">
										<div class="s-container">
											<swiper :options="swiperOption" ref="mySwiper"
												:pagination="{clickable:true}">
												<div class="swiper-slide" v-for="(item,index) in arcImpressList"
													:key="item.title"
													@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
													<div class="item">
														<div class="photo"> <img :src="item.image" alt=""></div>
														<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}
														</div>
													</div>
												</div>
											</swiper>
											<!-- 如果需要分页器 -->
											<div class="swiper-pagination">
											</div>
											<!-- 如果需要导航按钮 -->
											<div class="swiper-button-prev"></div>
											<div class="swiper-button-next"></div>
											<!-- 如果需要滚动条 -->
											<div class="swiper-scrollbar">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 大福湾资讯 GO-->
						<div class="m-newList list_info">
							<div class="info_tit">
								<div class="tit_left">
									<span>大福湾资讯</span>
									<el-divider direction="vertical"></el-divider>
									<span>REAL-TIME INFO</span>
								</div>
								<div class="tit_right f14" @click="go_list(124)">
									<span>查看更多</span>
									<el-divider direction="vertical"></el-divider>
									<span>MORE</span>
								</div>
							</div>
							<div class="liebiao_list wow fadeInUp animated">
								<div class="wow fadeInUp animated">
									<div class="liebiao_info css3" v-for="(item,index) in newsList">
										<div class="info_left col-xs-12 col-lg-3">
											<div class="border-hover css3"></div>
											<img class="css3" :src="item.image" />
										</div>
										<div class="info_right col-xs-12 col-lg-9"
											@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
											<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
											<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>

											<div class="right_down">
												<span>{{item.publishtime_text}}</span>
												<div class="right_down_div">
													<span class="commo_span">
														<img class="eye" src="@/assets/news/eye.svg" />
														<span>{{item.view}}</span>
													</span>
													<span class="commo_span">
														<img src="@/assets/news/comment.svg" />
														<span>{{item.comment_num}}</span>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<!--影视列表  资本列表  建设列表 GO-->
				<div class="count_info  wow fadeInUp animated" data-wow-delay="0.5s"
					v-if="jx_index!=26 && jx_index!=27 && jx_index!=94 && jx_index!=107">
					<div v-if="jx_index==list[newCurr].children[index].id"
						v-for="(item,index) in list[newCurr].children" class="subject_count_left col-xs-12 col-lg-10"
						:class="curr>0?'subject_count_newleft':''">
						<div class="info_tit">
							<div class="tit_left">
								<span>{{item.id!=25? item.cn_name :'艺品介绍'}}</span>
								<el-divider direction="vertical"></el-divider>
								<span>{{item.id!=25? item.en_name :'product introduction'}}</span>
							</div>

						</div>


						<div v-if="jx_index==6757" class="subj_content">
							<div
								v-html="lang=='CN' ?zidiyiDataDes.wenlv_info.cn_content:zidiyiDataDes.wenlv_info.en_content">
							</div>
						</div>

						<!--出版 GO-->
						<div v-if="jx_index==17" class="subj_content">
							<div
								v-html="lang=='CN' ?zidiyiDataDes.jxzb_gsjj.cn_content:zidiyiDataDes.jxzb_gsjj.en_content">
							</div>
						</div>


						<!--出版 GO-->
						<div v-if="jx_index==25" class="subj_content">
							<div
								v-html="lang=='CN' ?zidiyiDataDes.jxwl_cbxq.cn_content:zidiyiDataDes.jxwl_cbxq.en_content">
							</div>
						</div>

						<div v-if="content && (jx_index!=21 ||jx_index!=163)" class="subj_content">
							<div v-html="lang=='CN' ?content.cn_content:content.en_content"></div>
						</div>

						<!--  出版 -->
						<div class="dsj_list m-chuban" v-if="jx_index==25">
							<div class="dsj_list_tit wow fadeInUp animated" data-wow-delay="0.5s">
								<img class="xiangzuo" @click="next_you(activeName)" src="@/assets/img/zuo.png" />
								<div class="time_list wow fadeInUp animated" data-wow-delay="0.5s">
									<span class="css3" v-for="(item,index) in list2" v-if="list2"
										@click.stop="choose_year(item,index)"
										:class="item.en_name==activeName ? 'tit_active' : ''">
										{{item.en_name}}年
									</span>
								</div>
								<img class="xiangzuo" @click="next_zuo(activeName)" src="@/assets/img/you.png" />
							</div>
							<div class="subj_content">
								<div class="news-list row">
									<div class="cont  wow fadeInUp animated" v-for="(ite,i) in pdfList"
										data-wow-delay="0.5s">
										<div class="info_up" @click.stop="go_album(ite.id)">
											<img class="pointer" :src="ite.image" />
											<div class="title">{{ite.cn_title}}</div>
										</div>

										<view>

										</view>
									</div>
								</div>
							</div>
							<div class="info_tit">
								<div class="tit_left">
									<span>其他刊物</span>
									<el-divider direction="vertical"></el-divider>
									<span>other Publications</span>
								</div>
							</div>
							<div class="subj_content" v-if="jx_index==25">
								<div class="news-list row">
									<div class="cont  wow fadeInUp animated" v-for="(ite,i) in pdfList2"
										data-wow-delay="0.5s">
										<div class="info_up" @click.stop="go_album(ite.id)">
											<img class="pointer" :src="ite.image" />
											<div class="title">{{ite.cn_title}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div v-if="arcList.length>0 && list2.length==0" class="subj_content">

<!-- 							<div class="news-list other-list " v-if="jx_index==163">
								<div class="cont  wow fadeInUp animated" v-for="(item,i) in arcList"
									@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
									data-wow-delay="0.5s">
									<div :class="list[newCurr].children[index].id==26 ? 'picAcross':'pic'">
										<img class="pointer pointer_img css3" :src="item.image"
											:class="list[newCurr].children[index].id==26 ? 'picAcross':'pic'" />
									</div>
									<div class="infos">
										<div class="tit pointer">{{lang=='CN' ? item.cn_title : item.en_title}}</div>
									</div>

								</div>
							</div> -->


							
							<div class="news-list other-list " v-if="jx_index==21 || jx_index==35 || jx_index==36 || jx_index==163 ">
								<div class="cont  wow fadeInUp animated" v-for="(item,i) in arcList"
									@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
									data-wow-delay="0.5s">
									<div :class="list[newCurr].children[index].id==26 ? 'picAcross':'pic'">
										<img class="pointer pointer_img css3" :src="item.image"
											:class="list[newCurr].children[index].id==26 ? 'picAcross':'pic'" />
									</div>
									<div class="infos">
										<div class="tit pointer">{{lang=='CN' ? item.cn_title : item.en_title}}</div>
									</div>

								</div>
							</div>

							<!--影视资讯列表 GO-->
							<div class="news-list media-list" v-if="jx_index==22">
								<div class="cont  wow fadeInUp animated" v-for="(item,i) in arcList"
									@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
									v-if="i<4" data-wow-delay="0.5s">
									<img class="pointer" :src="item.image"
										:class="list[newCurr].children[index].id==26 ? 'picAcross':'pic'" />
									<div class="info" :style="i<4?'':'margin-left:0px'">
										<div class="tit line-1 pointer">{{lang=='CN' ?item.cn_title:item.en_title}}
										</div>
										<div class="txt line-2">{{lang=='CN' ?item.cn_cont:item.en_cont}}</div>
									</div>
								</div>
							</div>

							<!-- 影视传媒 GO-->
							<div class="pro-container " v-if="jx_index==22">
								<div class="info_tit">
									<div class="tit_left">
										<span>影视作品 </span>
										<el-divider direction="vertical"></el-divider>
										<span>MEDIA</span>
									</div>
									<div class="tit_right f14" @click="go_list(83)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>

								<div class="row" v-if="arcMediaList.length>0">

									<div class="item   wow fadeInUp animated" v-for="(item,index) in arcMediaList"
										@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink) ">
										<div class="photos video-photo">
											<img class="photo" :src="item.image" />
										</div>
										<div class="info">
											<div class="title line-2">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
											<div class="time">{{lang=='CN' ?item.cn_cont:item.en_cont}}</div>
										</div>

									</div>
								</div>
								<div class="row" v-else>
									暂无数据~
								</div>
							</div>
							
							
							
							<!-- 影视传媒资讯 GO-->
							<div class="m-newList spe list_info"  v-if="jx_index==22">
								<div class="info_tit">
									<div class="tit_left">
										<span>影视资讯</span>
										<el-divider direction="vertical"></el-divider>
										<span>REAL-TIME INFO</span>
									</div>
									<div class="tit_right f14" @click="go_list(108)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="liebiao_list wow fadeInUp animated">
									<div class="wow fadeInUp animated">
										<div class="liebiao_info css3" v-for="(item,index) in artMediaNewsList">
											<div class="info_left col-xs-12 col-lg-3">
												<div class="border-hover css3"></div>
												<img class="css3" :src="item.image" />
											</div>
											<div class="info_right col-xs-12 col-lg-9"
												@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
												<span
													class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
												<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
												<div class="right_down">
													<span>{{item.publishtime_text}}</span>
													<div class="right_down_div">
														<span class="commo_span">
															<img class="eye" src="@/assets/news/eye.svg" />
															<span>{{item.view}}</span>
														</span>
														<span class="commo_span">
															<img src="@/assets/news/comment.svg" />
															<span>{{item.comment_num}}</span>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							
							
							
						</div>

					</div>
					<div class="subject_count_right">
						<!-- 右悬浮2级菜单 -->
						<div class="flowing_panel" v-if="curr>0">
							<div class="flowing_panel_tabs" v-for="(item,index) in list" :key="index"
								@click="show_zb_list(index,type)">
								<span class="span"
									:class="curr==index?'active':''">{{lang=='CN' ?item.cn_name:item.en_name}}
									<img v-if="type==0 && curr==index" src="@/assets/img/liebiao_logo.png"
										@click="type =!type" />
									<img v-if="curr!=index" src="@/assets/img/liebiao_logo.png" @click="type =!type" />
									<span v-if="type==1 && curr==index" @click="type =!type">收起</span>
								</span>
								<div v-if="curr==index && type==1" class="flowing_panel_tabs_next"
									v-for="(ite,ind) in list[curr].children" @click="xuanzhong(ite,index)">
									<span
										:class="jx_index==ite.id ? 'next_active' : ''">{{lang=='CN' ?ite.cn_name:ite.en_name}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer @toggleNext="toggleNext"></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import BrandProject from '@/components/Brand_project'
	import CoreOrientalRacquer from '@/components/Core_oriental_lacquer'
	import {
		channel_list,
		archives_list,
		archives_list_new,
		add_pv,
		pdf_list,
		get_file_all,
		channel_detail,
		get_content,
		product_list
	} from '@/api/api.js'
	import {
		WOW
	} from 'wowjs'


	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper"
	import 'swiper/css/swiper.css'

	export default {
		components: {
			Header,
			Footer,
			swiper,
			swiperSlide,
			CoreOrientalRacquer,
			BrandProject
		},
		name: 'coreplate',
		data() {
			return {
				jx_index: '6567', //选择的2级id
				jx_index_name: '', //选择的2级名
				currentPage4: 1,
				yscurrentPage: 1,
				parent_id: 9,
				showBrand: 0,
				fuactive: 90, //大福湾印象选中分类
				categoryList: [], //印象子分类
				fuwanList: [], //大福湾纪事列表
				list: [{
					children: {
						id: ''
					}
				}], //二级栏目
				pdfList: [], //刊物列表
				pdfList2: [], //其他刊物
				list2: [], //出版年份列表
				curr: 0,
				newCurr: 0,
				type: false,
				page: 1,
				arcList: [], //内容列表
				arcMediaList: [], //影视传媒
				arcImpressList: [], //福湾印象

				total: '',
				lang: localStorage.getItem('lang') || 'CN',
				per_page: 6,
				proList: [],
				artOneList: [], //艺品芸列表1
				artTwoList: [], //艺品芸列表2
				artThreeList: [], //艺品芸列表3
				artFourList: [], //艺品芸收藏4
				artGoodsList: [], //商品列表
				artMediaNewsList: [], //影视传媒资讯列表
				
				categoryBgs: [],
				categoryBgsIndex: 3,
				yjy_index: 0,
				mySwiper: '',
				swiperOption: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 3,
					slidesPerGroup: 3,
					// 显示分页
					// pagination: {
					//   el: ".swiper-pagination",
					//   clickable: true //允许分页点击跳转
					// },
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				},
				newsList: [], //大福湾资讯
				archList: [], //展馆
				company_id: 1, //公司ID
				// banner: '',
				zidiyiData: {
					yipinyun_banner: {
						files: ''
					},
					yipinyun_qrcode: {
						files: ''
					},
					yipinyun_spacebanner: {
						files: ''
					},
					yipinyun_exhibition: {
						files: ''
					},
					c1: {
						files: ''
					},
					dafuwan_banner: {
						files: ''
					},
					audio: {
						files: ''
					},
					dafuwan_subbanner: {
						files: ''
					},
					dafuwan_qrcode: {
						files: ''
					},
					center_part: {
						files: ''
					},
					video_banner: {
						files: ''
					},
					subvideo: {
						files: ''
					},
				},
				zidiyiDataDes: {
					dafiwan_title: {
						cn_content: ''
					},
					jxwl_cbxq: {
						cn_content: ''
					},
					wenlv_info: {
						cn_content: ''
					},

					jxzb_gsjj: {
						cn_content: ''
					},
					gywm: {
						cn_content: ''
					},
					dafuwan_about: {
						cn_content: ''
					},
					video_introduce: {
						cn_content: ''
					},
					yipinyun_dec: {
						cn_content: ''
					},
					dafiwan_title: {
						cn_content: ''
					},
				},
				content:[],
				activeList: [],
				activeName: 2, //艺术私塾 手风琴
				artistTList: [], //艺品芸-艺术私塾-艺术大家
				shoolList: [], //艺术私塾
				salonList: [], //艺术沙龙
			}
		},
		created() {
			localStorage.setItem('current', 2)
			this.getAllNewsList()
			this.getProductList(6)
			this.getPdfList2()
			this.getPdfList1(157)
		},
		mounted() {
			this.getCateglory()
			this.parent_id = this.$route.query.parent_id
			this.getZidiyiData() //自定义图片
			this.getZidiyiDataDes()
			this.getImpressList(90, 0)
			if (typeof(this.$route.query.curr) == "number" || typeof(this.$route.query.curr) == "string") {
				// console.log(this.$route.query.curr, "==", this.$route.query.jx_index);
				this.curr = parseInt(this.$route.query.curr)
				this.newCurr = parseInt(this.$route.query.curr)
				if (this.$route.query.jx_index) {
					this.jx_index = parseInt(this.$route.query.jx_index)
				}
				this.type = true
				let data = {
					parent_id: this.parent_id
				}
				channel_list(data).then((res) => {
					if (res.code == 1) {
						this.list = res.data
						this.list = this.list.map(item => {
							let v = item.children.filter(tag => tag.model_tag !== '3' && tag.model_tag !==
								'0')
							item.children = v
							return item
						})
						this.list.map(item => {
							if (item.company_id == 3) {
								let v = {
									cn_name: "佳信文旅介绍",
									en_name: "Synopsis",
									id: 6757,
									outlink: "",
								}
								item.children.unshift(v)
								if (typeof(this.jx_index) != 'number') {
									this.jx_index = this.list[this.newCurr].children[0].id
									this.detail(this.list[this.newCurr].children[0].id)
									this.getArchivesList(this.list[this.newCurr].children[0].id)
								}
							}
						})
					}
				}).catch(err => {});
				this.refreshData()
				return
			}
			localStorage.setItem('current', 2)
			let data = {
				parent_id: this.parent_id,
				// isblock:false
			}
			channel_list(data).then(res => {
				if (res.code == 1) {
					this.list = res.data
					this.list = this.list.map(item => {
						let v = item.children.filter(tag => tag.model_tag !== '3' && tag.model_tag !== '0')
						item.children = v
						return item
					})
					this.list.map(item => {
						if (item.company_id == 3) {
							let v = {
								cn_name: "佳信文旅介绍",
								company_id: 3,
								content_id: 0,
								en_name: "Synopsis",
								id: 6757,
								isblock: 0,
								isnav: 1,
								isverify: 0,
								linkid: 0,
								linktype: "",
								model_tag: "",
								outlink: "",
								parent_id: 'wenlv_info',
								seo1: "",
								seo2: "",
								seo3: "",
								status: 1,
								status_text: "Status 1",
								type: "list",
								type_text: "List",
								weigh: 100,
							}
							item.children.unshift(v)
						}
					})
					if (this.list[this.curr].children[0].id == 6757) {
						this.jx_index = 6757
						this.arcList = []
						this.list2 = []
					} else {
						if (res.data) {
							this.detail(res.data[this.newCurr].children[0].id)
							this.getArchivesList(res.data[this.newCurr].children[0].id)
						}
					}
				}
			}).catch(err => {});
			this.addLocatPath()
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		methods: {
			getCateglory() {
				//获取二级栏目
				channel_list({
					parent_id: 78
				}).then(res => {
					if (res.code == 1) {
						this.categoryList = res.data
						res.data.map(item => {
							this.categoryBgs.push(item.image_text)
						})
					}
				}).catch(err => {});
			},
			getShoolList() {
				//获取艺术私塾 二级栏目
				channel_list({
					parent_id: 146
				}).then(res => {
					if (res.code == 1) {
						this.shoolList = res.data
					}
				}).catch(err => {});
			},
			/* 艺术私塾 手风琴 */
			handleChange(val) {
				console.log(val);
				if (typeof(val) == "String") {
					this.activeName = val
					return
				}

			},
			getAllNewsList() {
				let temp = [],
					data = {
						channel_id: '38,39,128,82,124,83,76,149,150,108', //149 艺术大家 150 艺术沙龙
						per_page: '6,6,6,8,6,8,6,3,4,10'
					}
				archives_list_new(data).then((res) => {
					temp = res.data
					temp.map(items => {
						items.data.map(item => {
							item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
								.en_content)
							item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
								.cn_content)
						})

					})

					this.artOneList = temp[0] ? temp[0].data : temp
					this.artTwoList = temp[1] ? temp[1].data : temp
					this.artThreeList = temp[2] ? temp[2].data : temp
					this.artFourList = temp[3] ? temp[3].data : temp
					this.newsList = temp[4] ? temp[4].data : temp //大福湾资讯
					this.arcMediaList = temp[5] ? temp[5].data : temp //影视资讯
					this.fuwanList = temp[6] ? temp[6].data : temp //
					this.artistTList = temp[7] ? temp[7].data : temp //艺术大家		
					this.salonList = temp[8] ? temp[8].data : temp //艺术沙龙	
					this.artMediaNewsList = temp[9] ? temp[9].data : temp //影视新闻资讯
							

				}).catch(err => {});
			},
			next_you(name) {
				var i = this.activeList.indexOf(name);
				if (0 < i && i < this.activeList.length) {
					this.getArchivesList(this.list2[i - 1].id)
					this.activeName = this.list2[i - 1].en_name
				}
			},
			next_zuo(name) {
				var i = this.activeList.indexOf(name);
				if (-1 < i && i < this.activeList.length - 1) {
					this.getArchivesList(this.list2[i + 1].id)
					this.activeName = this.list2[i + 1].en_name
				}
			},
			choose_year(item, index) {
				this.activeName = item.en_name
				this.getPdfList1(this.list2[index].id, 20)
			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			toggleNext(index, id) {
				this.curr = index
				this.newCurr = index
				this.jx_index = this.list[index].children[0].id
				if (id != undefined) {
					this.jx_index = id
				}
				this.detail(this.jx_index)
				this.getArchivesList(this.jx_index)
			},
			addLocatPath() {
				let data = {
					directions: '核心板块',
					path: window.location.href
				}
				add_pv(data).then(res => {}).catch(err => {});
			},
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},
			//刊物列表
			getPdfList1(id) {
				let data = {
					per_page: 16,
					page: 1,
					company_id: 3,
					channel_id: id
				}
				pdf_list(data).then(res => {
					if (res.code == 1) {

						this.pdfList = res.data.data
					}
				}).catch(err => {});
			},
			//其他刊物列表
			getPdfList2() {
				let data = {
					per_page: 16,
					page: 1,
					company_id: 3,
					channel_id: 100
				}
				pdf_list(data).then(res => {
					if (res.code == 1) {
						this.pdfList2 = res.data.data
					}
				}).catch(err => {});
			},

			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_file_all(data).then(res => {
					this.zidiyiData = res.data
				}).catch(err => {});
			},

			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},

			getArchivesList(id, num = null) {
				num == 20 ? this.per_page = 20 : this.per_page = 8
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then(res => {
					if (res.code == 1) {
						res.data.data.map(item => {
							item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
								.en_content)
							item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
								.cn_content)
						})

						this.arcList = res.data.data

						this.total = res.data.total
					}
				}).catch(err => {});
			},

			//福湾印象列表
			getImpressList(id, index) {
				let data = {
					channel_id: id,
					per_page: 7,
					page: 1
				}
				archives_list(data).then(res => {
					if (res.code == 1) {

						res.data.data.map(item => {
							item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
								.en_content)
							item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
								.cn_content)
						})
						this.arcImpressList = res.data.data
						this.categoryBgsIndex = index
						this.fuactive = id
						this.total = res.data.total
					}
				}).catch(err => {});
			},

			detail(str) { //获取自定义富文本 //str:关键字
				let data = {
					id: str
				}
				channel_detail(data).then(res => {
					// console.log("get_content", res.data.data);
					if (res.code == 1) {
						this.content = res.data.content
						// this.content=res.data[Object.keys(res.data)[0]]
					}
				}).catch(err => {});
			},
			chubanList(id) {
				let data = {
					parent_id: id
				}
				channel_list(data).then(res => {
					if (res.code == 1) {
						this.list2 = res.data
						this.activeList = res.data.map(item => item.en_name)
						this.activeName = this.list2[0].en_name
						this.pdfList(this.list2[0].id)
					}
				}).catch(err => {});
			},

			//侧边导航二级
			show_zb_list(num, type) {
				if (this.curr == num) {}
				if (this.curr != num) {
					this.curr = num
					this.type = true
				}
			},
			//侧边导航三级
			show_zb_list2(num, type) {
				if (this.curr == num) {
					this.type = !type
				}
				if (this.curr != num) {
					this.newCurr = num
					this.type = true
				}
			},

			refreshData() {
				this.arcList = []
				this.content = {}
				this.list2 = []

				if (this.jx_index == 25) {
					this.chubanList(this.jx_index)
					return
				}
				if (this.jx_index == 26) {
					this.getShoolList()
				}
				if (this.jx_index == 6757) {
					this.arcList = []
					this.list2 = []
					return
				}
				this.getArchivesList(this.jx_index)
				this.detail(this.jx_index)
			},
			xuanzhong(item, index) {
				this.newCurr = this.curr
				if (index) {
					this.newCurr = index
					this.curr = index
				}
				this.jx_index = item.id
				this.jx_index_name = item.cn_name
				this.arcList = []
				this.list2 = []
				console.log(item,index)
				let new_http = window.location.origin
				if (new_http == this.prod) {
					new_http = this.prod + '/web/'
				}
				let url = new_http + `#/coreplate?parent_id=9&curr=${this.curr}&jx_index=${this.jx_index}`
				window.history.replaceState(null, '', url);

				if (item.id == 25) {
					this.chubanList(item.id)
					return
				}
				if (item.id == 26) {
					this.getShoolList()
				}

				// if (item.id == 107) {
				// 	this.go(123)
				// 	return
				// }

				if (item.id == 6757) {
					this.arcList = []
					this.list2 = []
					return
				}
				if (item.id == 21) {
					this.getArchivesList(21)
					this.content = ''
					return
				}
				if (item.id == 163) {
					this.getArchivesList(163)
					this.content = ''
					return
				}
				
				this.getArchivesList(item.id)
				this.detail(item.id)
			},
			xuanzhong2(item, index) {
				this.curr = this.newCurr
				this.xuanzhong(item, index)
			},

			go_album(id) {
				this.$router.push({
					path: `photo?id=${id}`
				})
			},
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},


			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			getProductList(id) {
				let data = {
					company_id: id,
					per_page: 8,
					page: 1
				}
				product_list(data).then(res => {
					if (res.code == 1) {
						this.proList = res.data.data
						this.total = res.data.total
					}
				}).catch(err => {});
			},
			goShop(id) {
				this.$router.push({
					path: `shop`,
					query: {
						id: id
					}
				})
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_file_all(data).then(res => {
					this.zidiyiData = res.data
				}).catch(err => {});
			},
			// 获取自定义富文本
			getZidiyiDataDes() {
				let data = {
					keys: 'dafiwan_title,gywm,dafuwan_about,video_introduce,yipinyun_dec,jxwl_cbxq,wenlv_info,jxzb_gsjj'
				}
				get_content(data).then(res => {
					this.zidiyiDataDes = res.data
				}).catch(err => {});
			},
			//跳转更多
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},


			//大福湾印象 3个子类的列表
			getArchives(id, per_page) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then(res => {
					if (res.code == 1) {
						res.data.data.map(item => {
							item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
								.en_content)
							item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
								.cn_content)
						})
						this.archList = res.data.data
						this.total = res.data.total
					}
				}).catch(err => {});
			},


			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},
			go_list2() {
				if (this.yjy_index == 0) {
					this.$router.push({
						path: `list`,
						query: {
							parent_id: this.parent_id,
							id: 79
						}
					})
				}
				if (this.yjy_index == 1 || this.yjy_index == 81) {
					this.$router.push({
						path: `list`,
						query: {
							parent_id: this.parent_id,
							id: 80
						}
					})
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.m-hxbk {
		.hxbk_count {
			.list_img {
				width: 100%;
			}


		}

	}

	.s-container {
		width: 1120px;
		height: 370px;
		overflow: hidden;
	}

	.swiper-container {
		margin-top: 55px;
	}

	.swiper-wrap {
		width: 1119px;
		height: 370px;
		position: absolute;
		bottom: 40px;
		right: 40px;
		overflow: hidden;
	}

	.swiper-wrap .swiper-button-prev,
	.swiper-wrap .swiper-button-next {
		width: 114px;
		height: 35px;
		left: initial;
		position: absolute;
		top: 22px;
	}

	.swiper-wrap .swiper-button-prev::after,
	.swiper-wrap .swiper-button-next::after {
		display: none;
	}

	.swiper-wrap .swiper-button-prev {

		background: rgba(255, 255, 255, .2) url(~@/assets/img/prevnext.png) 0 0 no-repeat;
		right: 148px;
	}

	.swiper-wrap .swiper-button-next {
		background: rgba(255, 255, 255, .2) url(~@/assets/img/prevnext.png) 0 -35px no-repeat;
		right: 14px;
	}

	.swiper-wrap .swiper-button-prev:hover,
	.swiper-wrap .swiper-button-next:hover {
		background-color: rgba(0, 97, 112, .5);
	}




	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}


	.picAcross {
		height: 194px;
		overflow: hidden;
	}

	.m-hxbk .introduce {
		width: 1400px;
		height: 530px;
		margin: 100px auto;
		position: relative;
	}

	.m-hxbk .introduce .cont_l {
		width: 1040px;
		height: 530px;
		float: left;
		background: #ebf3f5;
	}

	.m-hxbk .cont_l .info_tit {
		margin: 60px 0 0 40px;
	}

	.m-hxbk .cont_l .cont {
		width: 655px;
		height: 270px;
		overflow: hidden;
		margin: 40px 0 0 40px;
	}


	.m-hxbk .introduce .pic {
		width: 660px;
		height: 440px;
		position: absolute;
		cursor: pointer;
		top: 46px;
		right: 0px;
	}



	.m-hxbk .count_info .subject_count_right {
		position: absolute;
		right: 0;
		top: 0px
	}

	.m-hxbk {
		background: #fff;
	}

	.m-hxbk .hxbk_count {
		padding: 0 30px 30px;
	}

	.m-hxbk .count_info {
		margin: 50px auto;
		width: 1400px;
		position: relative;
		min-height: 400px;
	}


	.m-hxbk .info_tit span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.m-hxbk .info_tit .tit_right span:first-child {
		font-size: 16px;
		// color: #999999;
		font-weight: normal;
	}



	.m-hxbk .info_tit span:last-child {
		font-size: 14px;
		color: #000;
	}

	.m-hxbk .subj_content {
		margin: 20px 0;
	}

	.m-hxbk .subj_content .other-list {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.m-hxbk .subj_content .other-list .pic {
		height: 340px !important;
	}

	.m-chuban .cont {
		width: initial !important;
		height: initial !important;
	}

	.m-hxbk .hover_span {
		cursor: pointer;
	}


	.m-hxbk .subject_count_right .commo_div {
		background: #006170;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 15px 20px;
		color: #fff;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
	}

	.m-hxbk .subject_count_right .commo_div img {
		width: 15px;
		height: 15px;
	}

	.m-hxbk .commo_list {
		border: 1px solid #dddee4;
		margin-bottom: 10px;
	}

	.m-hxbk .commo_list {
		border-bottom: none;
	}

	.m-hxbk .commo_list span {
		display: block;
		width: 100%;
		padding: 15px 20px;
		text-align: center;
		background: #f0f4f5;
		border-bottom: 1px solid #dddee4;
		color: #000;
		font-weight: bold;
		cursor: pointer;
	}

	.m-hxbk .commo_list .active_style {
		border: 1px solid #006170;
		box-shadow: 5px 7px 10px #cddadc;
		color: #307f8b;
		background: #fff;
		margin-bottom: 10px;
	}

	.media-list {
		width: 1400px;
		overflow: hidden;
	}

	.media-list .cont:nth-child(1) {
		width: 924px;
		height: 520px;
		margin: 0;
		overflow: hidden;
		float: left;
	}

	.media-list .cont:nth-child(1) img {
		width: 925px;
		height: 520px !important;
		object-fit: cover;

	}

	.media-list .cont {
		width: 320px;
		height: 480px;
		float: left;
		margin: 25px 0 0 40px;
		overflow: hidden;
	}

	.media-list .cont:nth-child(2),
	.media-list .cont:nth-child(3),
	.media-list .cont:nth-child(4) {
		width: 450px;
		height: 156px;
		margin: 0 0 26px 25px !important;
		float: left;
		background: #f0f4f5;
	}

	.media-list .cont:nth-child(4) {
		margin-bottom: 0 !important;
	}

	.media-list .cont:nth-child(2) img,
	.media-list .cont:nth-child(3) img,
	.media-list .cont:nth-child(4) img {
		width: 104px;
		height: 156px;
		object-fit: cover;
		float: left;
	}

	.media-list .cont:nth-child(4n+1) {
		margin-left: 0;
	}

	.media-list .cont img {
		width: 100%;
		object-fit: cover;
	}


	.media-list .info {
		margin: 20px 0 0 30px;
		width: 296px;

		overflow: hidden;
		float: left;
	}


	.media-list .tit {
		font-size: 24px;
		color: #000000;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	.media-list .txt {
		font-size: 14px;
		color: #999999;
		overflow: hidden;
		margin-top: 20px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}


	/*其他列表数据*/
	.other-list .cont {
		width: 340px;
		float: left;
		margin: 0 0 30px 30px;
		overflow: hidden;
	}

	.other-list .cont:nth-child(3n+1) {
		margin-left: 0;
	}


	.other-list .cont img {
		width: 340px;
		height: 340px;
		object-fit: cover;
	}


	.other-list .info {
		display: none;
		margin: 20px 0 0 30px;
		width: 296px;
		overflow: hidden;
		float: left;
	}


	.other-list .tit {
		font-size: 18px;
		color: #000000;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		margin-top: 10px;
	}

	.other-list .txt {
		font-size: 14px;
		color: #999999;
		overflow: hidden;
		margin-top: 20px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}





	/* 艺品芸 */
	.m-hxbk .mokuai_js .gg_tit {
		font-size: 16px;
		font-weight: bold;
		position: relative;
		padding-left: 15px;
		margin-bottom: 20px;
	}

	.m-hxbk .mokuai_js .gg_tit::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 3px;
		height: 20px;
		background: #006170;
	}

	.m-hxbk .mokuai_js .js_neirong {
		color: #333;
		line-height: 30px;
		margin-bottom: 20px;
	}

	.m-hxbk .mokuai_js .mokuai_info img {
		width: 100%;
	}

	.m-hxbk .mokuai_js .mokuai_info {
		position: relative;
	}

	.m-hxbk .mokuai_js .mokuai_info .posi_div {
		position: absolute;
		left: 15px;
		bottom: 0;
		width: 91%;
		height: 30px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0 10px;
		background: rgba(0, 0, 0, 0.4);
		color: #fff;
		line-height: 30px;
	}

	.m-hxbk .mokuai_js .mokuai_info .posi_div span:last-child {
		font-size: 18px;
		font-weight: bold;
	}

	.m-hxbk .cbList_info .info_down {
		text-align: center;
		margin-top: 10px;
		color: #000;
	}

	.m-hxbk .cbList_info {
		margin-bottom: 20px;
	}

	.m-hxbk .cb_list {
		margin-top: 50px;
	}


	.col-xs-12,
	.col-lg-3 {
		padding: 0;
	}

	a:hover {
		text-decoration: none;
	}

	.row {
		margin: 0;
	}

	/*艺品芸 GO*/
	.m-yipinyun {
		.wrap-y {
			width: 1400px;
			margin: 100px auto;

			.yipinyun-dec {
				overflow: hidden;

				.tit {
					height: 50px;
					overflow: hidden;

					.logo,
					.img {
						width: 120px;
						height: 50px;
						float: left;
					}

					.tit_left {
						margin-left: 40px;
					}
				}

				.cont {
					width: 100%;
					float: left;
					height: auto !important;
					overflow: hidden;

					.txt {
						font-size: 18px;
						width: 1040px;
						float: left;
						margin-top: 37px;
						overflow: hidden;
					}
				}

				.qrcode {
					width: 230px;
					overflow: hidden;
					float: right;
					margin-right: 44px;
					text-align: center;
					img{width: 230px;height: 230px;}
					.tip {
						width: 230px;
						line-height: 50px;
						color: #000000;
						text-align: center;
						letter-spacing: 10px;
						text-indent: 15px;
						font-size: 18px;
					}

				}
			}


		}
	}


	/**通用标题 */
	.info_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
		cursor: pointer;
	}

	.info_tit .active {
		border: 2px solid #006170;
		box-shadow: 5px 7px 10px #cddadc;
		color: #000;
	}

	.info_tit .tit_left span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.info_tit .tit_left span:last-child {
		font-size: 14px;
		color: #999;
	}



	/*艺品芸空间 GO*/
	.sub-banner {
		width: 1400px;
		height: 580px;
		margin: 30px auto;
		position: relative;
		overflow: hidden;
	}

	.sub-banner .pic img {
		width: 100%;
	}

	.sub-banner .items {
		width: 100%;
		height: 100px;
		position: absolute;
		bottom: 0px;
		left: 0px;
		margin: 0;
		display: flex;
		flex-direction: row-reverse;
	}

	.sub-banner .item {
		margin: 0px;
		width: 20%;
		height: 100px;
		float: left;
		background: #585359;
		position: relative;
		cursor: pointer;
	}

	.sub-banner .item:hover {
		background: #006170;

	}

	.sub-banner .item::before {
		content: '';
		width: 1px;
		background: #767378;
		display: block;
		height: 100%;
		position: absolute;
		top: 0px;
		left: 0px;
	}

	.sub-banner .item span {
		width: 170px;
		height: 100px;
		line-height: 100px;
		font-size: 24px;
		color: #ffffff;
		display: block;
		margin-left: 48px;
		letter-spacing: 5px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.sub-banner .item img {
		width: 17px;
		height: 13px;
		display: block;
		position: absolute;
		top: 44px;
		right: 40px;
	}

	/* 艺品芸商城 GO*/
	.pro-container {
		margin-top: 60px;

		.title {
			margin-top: 25px;
			height: 30px;
			line-height: 30px;
			color: #333333;
			font-size: 18px;

			&:hover {
				color: #006170;
				cursor: pointer;
			}
		}

		.item {
			width: 320px;
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;
			float: left;
			margin: 0 0 30px 40px;

			.info_tit {
				margin-bottom: 37px;
			}

			.photos {
				width: 100%;
				height: 320px;
				position: relative;
				overflow: hidden;

				.photo {
					width: 100%;
					object-fit: cover;

				}

				&.video-photo,
				img {
					height: 480px;
				}
			}
		}

		&:nth-child(4n+1) {
			margin-left: 0px;
		}

		a {
			display: block;
		}

		.time {
			margin-top: 10px;
			color: #666666;
			font-size: 14px;
			
			&:hover {
				color: #666666;
			}
		}

		.mask {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			z-index: 2;
			opacity: 0;
			background: rgba(0, 0, 0, .5);
		}

		&:hover {
			.item:hover {
				.mask {
					opacity: 1;
				}
			}
		}

	}



	.pro-container .item .ewm {
		width: 200px;
		height: 200px;
		position: absolute;
		top: 40px;
		left: 50%;
		z-index: 3;
		margin: 0px 0 0 -100px;
		transform: scale(0);
		-webkit-transform: scale(0);
		-moz-transform: scale(0);
		-o-transform: scale(0);
		-ms-transform: scale(0);
	}

	.pro-container .item .ewm img {
		width: 200px;
		height: 200px;
		object-fit: cover;
	}

	.pro-container .item:hover .ewm {

		transform: scale(1);
		-webkit-transform: scale(1);
		-moz-transform: scale(1);
		-o-transform: scale(1);
		-ms-transform: scale(1);

	}

	.pro-container .item .tips {
		width: 100%;
		line-height: 60px;
		font-size: 18px;
		color: #ffffff;
		text-align: center;
	}

	/**展览展示 GO**/
	.exhibition-container {
		overflow: hidden;
		margin-top: 82px;
	}

	.exhibition-container .info_tit {
		overflow: hidden;
		margin-bottom: 37px;
	}

	.exhibition-container .cont-left {
		width: 1040px;
		height: 600px;
		float: left;
		cursor: pointer;
	}

	.exhibition-container .cont-right {
		width: 320px;
		height: 600px;
		margin-left: 40px !important;
		float: left;
	}

	.exhibition-container ul,
	.exhibition-container li {
		margin: 0;
		padding: 0;
	}

	.exhibition-container li {
		height: 190px;
		border-bottom: 1px solid #f0f4f5;
		margin-top: 22px;
	}

	.exhibition-container li:last-child {
		border-bottom: 0px;
	}

	.exhibition-container li:hover {
		cursor: pointer;
	}

	.exhibition-container .cont-right .tit {
		width: 100%;
		height: 60px;
		line-height: 60px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		font-size: 24px;
		color: #000000;
	}

	.exhibition-container li:nth-child(1) {
		margin-top: 0;
	}

	.exhibition-container .cont-right .tit:hover {
		color: #006170;
	}

	.exhibition-container .cont-right .time {
		width: 100%;
		line-height: 25px;
		height: 25px;
		font-size: 16px;
		color: #8d8d8d;
	}

	.exhibition-container .cont-right .txt {
		width: 100%;
		line-height: 30px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		font-size: 16px;
		margin-top: 6px;
		color: #8d8d8d;
	}

	.exhibition-container .cont-right .txt:hover {
		opacity: 0.8;
	}

	/** 艺术私塾 GO*/
	.pro-school {
		margin-top: 96px;

		.info_tit {
			margin-bottom: 37px;
		}

		.pro_school {
			.school_left {
				width: 780px;
				height: 460px;
				float: left;
				cursor: pointer;
				overflow: hidden;

				.el-collapse {
					display: flex;
					flex-direction: row;

					.is-active {
						width: 600px !important;
						height: 460px;
					}

					/deep/.el-collapse-item:nth-child(1) {
						.el-collapse-item__header {
							background: url(~@/assets/img/jt1.jpg) center no-repeat;
						}
					}

					/deep/.el-collapse-item:nth-child(2) {
						.el-collapse-item__header {
							background: url(~@/assets/img/ft1.jpg) center no-repeat;
						}
					}

					/deep/.el-collapse-item:nth-child(3) {
						.el-collapse-item__header {
							background: url(~@/assets/img/dj1.jpg) center no-repeat;
						}
					}

					.el-collapse-item {
						width: 80px;
						height: 460px;
						margin-top: -1px;
						margin-right: 10px;

						.el-collapse-item__header {
							height: 460px;
							position: absolute;

						}

						/deep/.el-collapse-item__header {
							width: 80px;
							height: 460px;
							border-bottom: 0px solid #EBEEF5;
							display: flex;
							flex-direction: column;
							padding: 110px 30px 30px 30px;
							font-size: 20px;
							background: #585359;
							color: #FFFFFF;
							line-height: 32px;

							/deep/.el-collapse-item__arrow {
								display: none;
							}

							.el-collapse-item__arrow {
								display: none;
							}
						}

						/deep/.is-active {
							position: absolute;
							display: none;
						}

						.el-collapse-item__content {
							img {
								width: 600px;
								height: 460px;
							}

							.title {
								height: 60px;
								position: relative;
								color: #fff;
								background: #585359;
								font-size: 24px;
								bottom: 60px;
								display: flex;
								align-items: center;
								padding: 0 30px;
								line-height: 60px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
							}
						}
					}
				}
			}

			.school_right {
				width: 590px;
				height: 460px;
				float: left;
				cursor: pointer;
				margin-left: 30px;

				.right_header {
					position: relative;
					top: -8px;

					.info_tit {
						margin-top: 0px;
						margin-bottom: 0px;

						.tit_left {
							span[data-v-37773d3a]:first-child {
								font-size: 24px;
								color: #000;
								font-weight: bold;
							}
						}
					}
				}

				.right_list {
					display: flex;
					flex-direction: row;
					justify-content: flex-start;
					position: relative;
					padding: 13px 13px;
					cursor: pointer;
					width: calc(100% + 13px);
					position: relative;
					left: -13px;

					.info_left {
						width: 180px;
						height: 120px;

						img {
							width: 180px;
							height: 120px;
							object-fit: cover;
						}
					}

					.info_right {
						margin-left: 20px;

						.right_tit {
							width: 100%;
							height: 90px;
							line-height: 45px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							font-size: 24px;
							color: #666666;
						}

						.right_down {
							width: 100%;
							line-height: 25px;
							height: 25px;
							font-size: 16px;
							color: #8d8d8d;
						}
					}
				}

				.right_list:hover {
					background: #f0f4f5;
				}

				.right_list::after {
					content: '';
					width: calc(100% - 60px);
					background: #f0f4f5;
					display: block;
					// height: 1px;
					position: absolute;
					bottom: 0px;
					left: 30px;
				}

				.right_list:last-child::after {
					display: none;
				}
			}
		}
	}

	/** 艺术沙龙 GO*/
	.pro-salon {
		margin-top: 86px;

		.salon_content {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: 32px;

			.item {
				cursor: pointer;

				.pic {
					img {
						width: 680px;
						height: 400px;
					}
				}

				.bottom {
					width: 680px;
					margin: 20px 0 40px 0;
					display: flex;
					align-items: center;
					justify-content: space-between;
					color: #333333;

					.title {
						width: 620px;
						height: 43px;
						line-height: 43px;
						font-size: 18px;
					}

					.icom_f {
						width: 60px;
						height: 43px;
						border: 1px solid #e6e6e6;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 17px;
							height: 14px;
						}
					}
				}

				.bottom:hover {
					color: #006170;
					cursor: pointer;
				}
			}
		}
	}


	/**影视传媒资讯 GO*/
	.m-media-newslist {
		margin-top: 60px;
	}

	.m-media-newslist .info_tit {
		margin-bottom: 25px;
	}

	.m-media-newslist .liebiao_list {
		margin-top: 3px;
	}

	.m-media-newslist .liebiao_info {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		position: relative;
		padding: 30px;
		cursor: pointer;
		width: calc(100% + 60px);
		position: relative;
		left: -30px;
	}

	.m-media-newslist .liebiao_info:hover {
		background: #f0f4f5;
	}

	.m-media-newslist .liebiao_info::after {
		content: '';
		width: calc(100% - 60px);
		background: #f0f4f5;
		display: block;
		height: 1px;
		position: absolute;
		bottom: 0px;
		left: 30px;
	}

	.m-media-newslist .liebiao_info:last-child::after {
		display: none;
	}

	.m-media-newslist .info_right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		z-index: 5;
		color: #666666;
	}

	.m-media-newslist .right_down {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #999;
	}

	.m-media-newslist .commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.m-media-newslist .commo_span img {
		width: 20px;
		margin-right: 5px;
	}

	.m-media-newslist .right_down_div {
		display: flex;
		align-items: center;
	}

	.m-media-newslist .right_tit {
		font-size: 24px;
		color: #000;
	}

	.m-media-newslist .right_tit span {
		color: #999 !important;
	}

	.m-media-newslist .right_tit:hover {
		color: #006170;
	}

	.m-media-newslist .info_tit .tit_right {
		font-size: 16px;
		color: #999999;
	}

	.m-media-newslist .info_tit:hover .tit_right {
		color: #006170;
	}





	/**艺品芸资讯 GO*/
	.m-newList {
		margin-top: 60px;
	}
	.m-newList.spe{ margin-top:0px;}
	.m-newList .info_tit {
		margin-bottom: 25px;
	}

	.m-newList .liebiao_list {
		margin-top: 3px;
	}

	.m-newList .liebiao_info {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		position: relative;
		padding: 30px;
		cursor: pointer;
		width: calc(100% + 60px);
		position: relative;
		left: -30px;
	}

	.m-newList .liebiao_info:hover {
		background: #f0f4f5;
	}

	.m-newList .liebiao_info::after {
		content: '';
		width: calc(100% - 60px);
		background: #f0f4f5;
		display: block;
		height: 1px;
		position: absolute;
		bottom: 0px;
		left: 30px;
	}

	.m-newList .liebiao_info:last-child::after {
		display: none;
	}

	.m-newList .info_right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		z-index: 5;
		color: #666666;
	}

	.m-newList .right_down {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #999;
	}

	.m-newList .commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.m-newList .commo_span img {
		width: 20px;
		margin-right: 5px;
	}

	.m-newList .right_down_div {
		display: flex;
		align-items: center;
	}

	.m-newList .right_tit {
		font-size: 24px;
		color: #000;
	}

	.m-newList .right_tit span {
		color: #999 !important;
	}

	.m-newList .right_tit:hover {
		color: #006170;
	}

	.m-newList .info_tit .tit_right {
		font-size: 16px;
		color: #999999;
	}

	.m-newList .info_tit:hover .tit_right {
		color: #006170;
	}


	/* 大福湾 */
	.map {
		height: 400px;
		width: 100%;
	}

	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.m-newList .col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.sub_area {
		width: 1400px;
		height: 512px;
		margin: 60px auto 0;
		position: relative;
		overflow: hidden;
	}

	.sub_area .tit {
		color: #000000;
		font-size: 36px;
		height: 114px;
		line-height: 114px;
		position: relative;
		z-index: 3;
	}

	.sub_area .pic {
		width: 1094px;
		height: 318px;
		position: relative;
		z-index: 3;
	}

	.sub_area .bg {
		width: 1080px;
		height: 512px;
		position: absolute;
		right: 0;
		top: 0;
		background: #EBF3F5;
	}

	.sub_area .more {
		width: 320px;
		height: 80px;
		position: absolute;
		left: 0;
		bottom: 1px;
		background: #006170 !important;
	}

	.sub_area .more span {
		padding-right: 70px;
		font-size: 18px;
	}

	/**大福湾纪事 GO**/
	.fuwan-list {
		overflow: hidden;
		margin-top: 40px;
	}




	.m-dafuwan .introduce-fw {
		width: 1400px;
		margin: 100px auto 0;

	}


	.m-dafuwan .introduce-fw .about {
		margin-top: 20px;
		font-size: 18px !important;
	}

	.m-audio {
		width: 1400px;
		height: 160px;
		margin: 60px auto 0;
		overflow: hidden;

	}

	.m-audio img {
		float: left;
	}

	.m-audio .cont {
		width: 1240px;
		height: 100px;
		float: left;
	}

	.m-audio .cont .tit {
		width: 1240px;
		height: 60px;
		line-height: 60px;
	}

	.m-audio .cont span:first-child {
		font-size: 24px;
		padding-left: 30px;
	}

	.m-audio .cont span:nth-child(2) {
		font-size: 16px;
	}

	.m-audio .cont span:last-child {
		float: right;
		font-size: 16px;
		cursor: pointer;
	}

	.m-audio .cont span:last-child:hover {
		color: #006170;
	}

	.wrap {
		float: left;
		width: 1240px;
		height: 100px;
		background: #ebf3f5;
		position: relative;
	}

	audio {
		position: absolute;
		top: -20px;
		width: 1240px;
		height: 100px;
	}

	audio::-webkit-media-controls-play-button {
		color: #006170;
	}

	audio::-moz-media-controls-play-button {
		color: #006170;
	}

	audio::-moz-media-controls-play-button {
		color: #006170;
	}

	audio::-ms-media-controls-play-button {
		color: #006170;
	}





	.m-dafuwan .items {
		margin-bottom: 30px;
		height: 460px;
	}

	.m-dafuwan .items .info_img {
		width: 100%;
	}

	.m-dafuwan .items .hover_img {
		overflow: hidden;
		height: 260px;
		object-fit: cover;
	}

	.dafuwan-list {
		width: calc(100% + 40px);
		position: relative;
		left: -20px;
	}

	.dafuwan-list .hover_img img {
		height: 260px;
		object-fit: cover;
	}


	.m-dafuwan .items .info_img:hover {
		transform: scale(1.2)
	}

	.m-dafuwan .items .info_footer {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.m-dafuwan .items .info_footer .line1 {
		width: 80px;
		height: 2px;
		background: #006170;
	}

	.m-dafuwan .items .info_footer_left {
		height: 40px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.m-dafuwan .items .info_footer_left span {
		color: #999;
	}

	.m-dafuwan .items .info_footer_right {
		height: 40px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	.m-dafuwan .items .info_footer_right div {
		width: 150px;
		height: 35px;
		line-height: 35px;
		text-align: center;
		background: #006170;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.m-dafuwan .items .info_footer_right div img {
		margin-left: 10px;
	}

	.m-dafuwan .items .info_tit {
		margin: 20px 0;
		color: #1a1a1a;
		font-size: 16px;
		line-height: 30px;
		overflow: hidden;
		height: 60px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;

	}

	.m-dafuwan .col-lg-5 {
		padding-left: 0 !important;
	}

	.m-dafuwan .col-lg-7 {
		padding-right: 0 !important;
	}

	.m-dafuwan .col-lg-2 {
		padding-left: 0 !important;
	}

	.m-dafuwan .col-lg-10 {
		padding: 0 !important;
	}

	.m-dafuwan .col-lg-4 {
		padding: 20px !important;
	}


	/**福湾印象 GO**/
	.m-dafuwan {
		background: #fff;
	}

	.m-dafuwan .list_info {
		margin: 50px auto;
		max-width: 1400px;
		position: relative;

	}

	.m-dafuwan .ggz_posi {
		position: absolute;
		right: 0;
		top: 0px;
		height: 512px;
		width: 360px;
		text-align: center;
		padding: 64px 0 40px 0;
	}

	.m-dafuwan .list_count .list_img {
		width: 100%;
	}

	.m-dafuwan .ggz_posi div:nth-child(2) {
		margin: 30px 0 10px;
	}

	.m-dafuwan .ggz_posi div:nth-child(3) {
		color: #000000;
		font-size: 18px;
		letter-spacing: 15px;
	}

	.m-dafuwan .info_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		cursor: pointer;
	}

	.m-dafuwan .info_tit .active {
		border: 2px solid #006170;
		box-shadow: 5px 7px 10px #cddadc;
		color: #000;
	}

	.m-dafuwan .tit_left span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.m-dafuwan .tit_left span:last-child {
		font-size: 14px;
		color: #999;
	}

	.m-dafuwan .hover_span {
		cursor: pointer;
	}

	.m-dafuwan .line {
		width: 200px;
		height: 3px;
		background: #006170;
		margin-top: 40px;
	}


	.m-dafuwan .js_nr {
		line-height: 30px;
		color: #333;
	}

	.m-dafuwan .more_btn span,
	.m-dafuwan .more_btn img {
		position: relative;
		z-index: 9;
	}

	.m-dafuwan .more_btn {
		width: 320px;
		position: relative;
		overflow: hidden;
		height: 80px;
		text-align: center;
		line-height: 80px;
		color: #fff;
		background: #006170;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.m-dafuwan .more_btn span:nth-child(2) {
		padding: 0 10px;
	}


	.m-dafuwan .more_btn::after {
		content: '';
		width: 100%;
		height: 100%;
		background: #333333;
		display: block;
		position: absolute;
		top: 0;
		left: -100%;
		z-index: 8;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.m-dafuwan .more_btn:hover::after {
		left: 0px;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}


	.m-dafuwan .info_footer_right .more {
		position: relative;
		overflow: hidden;
	}

	.info_footer_right .more span,
	.info_footer_right .more img {
		position: relative;
		z-index: 9;
	}

	.m-dafuwan .info_footer_right .more::after {
		content: '';
		width: 100%;
		height: 100%;
		background: #333333;
		display: block;
		position: absolute;
		top: 0;
		left: -100%;
		z-index: 8;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.m-dafuwan .info_footer_right .more:hover::after {
		left: 0px;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.m-dafuwan .yjy {
		margin-top: 70px;
	}


	.m-dafuwan .impress {
		width: 1400px;
		margin: 20px auto 0;
		position: relative;
		overflow: hidden;
		height: 710px;
		background: url(../assets/img/none.jpg);
	}

	.m-dafuwan .thumbs {
		overflow: hidden;
	}


	.m-dafuwan .fuwantit {
		width: 342px;
		height: 80px;
		text-align: center;
		line-height: 80px;
		font-size: 18px;
		color: #000000;
		float: left;
		margin-left: 10px;
		cursor: pointer;
		background: #F0F4F5;
	}

	.m-dafuwan .fuwantit.active,
	.m-dafuwan .fuwantit:hover {
		background: #006170;
		color: #ffffff;
	}

	.m-dafuwan .fuwantit:first-child {
		margin-left: 0;
	}

	.m-dafuwan .impress .swiper-slide {
		/* 		width: 380px !important; */
		height: 260px;
	}

	.m-dafuwan .impress .item {
		width: 360px;
		height: 260px;
		overflow: hidden;
		margin-right: 20px;
		float: left;
		background: #ffffff;
		cursor: pointer;
		margin-bottom: 24px;
	}

	.m-dafuwan .impress .item img {
		width: 360px;
		height: 200px;
		object-fit: cover;
	}


	.m-dafuwan .impress .tit {
		font-size: 18px;
		line-height: 60px;
		height: 60px;
		color: #000000;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0 10px;
	}

	.m-dafuwan .right_count {
		height: 410px;
		background: #f0f4f5;
		padding: 0px 50px;
		overflow: hidden;
	}

	.m-dafuwan .right_count .count_info {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding-bottom: 37px;
		margin: 40px 0 0 0 !important;
		border-bottom: 1px solid #e6e6e6;
		align-items: center;
		width: 1070px;
	}

	.m-dafuwan .right_count .count_info:last-child {
		border-bottom: none;
		padding-bottom: 0 !important;
	}

	.m-dafuwan .right_count .count_info div span:nth-child(1) {
		font-size: 14px;
		color: #9f9f9f;
	}

	.m-dafuwan .right_count .count_info div span:nth-child(2) {
		font-size: 16px;
		color: #000000;
		margin-left: 100px;
	}



	.m-dafuwan .count_info .xiang_btn {
		display: block;
		width: 120px;
		overflow: hidden;
		text-align: center;
		height: 25px;
		line-height: 25px;
		color: #fff;
		background: #006170;
		cursor: pointer;
		position: relative;
	}

	.m-dafuwan .count_info .xiang_btn em {
		position: relative;
		z-index: 9;
		font-style: normal;
	}

	.m-dafuwan .count_info .xiang_btn::after {
		content: '';
		width: 100%;
		height: 100%;
		background: #333333;
		display: block;
		position: absolute;
		top: 0;
		left: -100%;
		z-index: 8;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.m-dafuwan .count_info .xiang_btn:hover::after {
		left: 0px;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	/**福湾资讯 GO*/
	.m-newList .info_tit {
		margin-bottom: 0;
	}

	.m-newList .liebiao_list {
		margin-top: 3px;
	}


	.m-newList .info_left {
		margin-right: 30px;
		overflow: hidden;
		position: relative;
		z-index: 5;
	}

	.m-newList .info_left img {
		width: 100%;
		height: 200px;
	}

	.m-newList .info_left img:hover {
		transform: scale(1.2)
	}

	.m-newList .info_right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		z-index: 5;
		color: #666666;
	}

	.m-newList .right_down {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #999;
	}

	.m-newList .commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.m-newList .commo_span img {
		width: 20px;
		margin-right: 5px;
	}

	.m-newList .right_down_div {
		display: flex;
		align-items: center;
	}

	.m-newList .jieshao {
		font-size: 14px;
		color: #999;
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;


	}

	.m-newList .jieshao:hover {
		opacity: 0.8;
	}

	.info_tit .tit_right {
		font-size: 14px;
	}


	.m-newList .info_tit:hover .tit_right {
		color: #006170;
	}


	@media screen and (min-width: 1000px) and (max-width: 1399px) {
		.sub_area {
			width: 100%;
		}

		.sub_area .pic {
			width: calc(100% - 360px);
			overflow: hidden;
		}
	}
</style>
<style scoped lang="scss">
	.m-hxbk {
		.hxbk {
			&_count {

				/** 右侧悬浮2级菜单*/
				.flowing_panel {
					top: 90px;
					position: relative;
					width: 230px;

					.flowing_panel_tabs {
						.span {
							width: 230px;
							background: #006170;
							display: flex;
							padding: 15px 20px;
							color: #fff;
							justify-content: space-between;
							margin-bottom: 10px;
							cursor: pointer;
						}

						.flowing_panel_tabs_next {
							position: relative;
							left: 0px;

							&:hover {
								span {
									background: #ffffff;
									color: #307f8b;
								}

							}

							span {
								display: block;
								width: 100%;
								padding: 15px 20px;
								text-align: center;
								background: #f0f4f5;
								border-bottom: 1px solid #dddee4;
								color: #000;
								cursor: pointer;
							}

							.next_active {
								border: 1px solid #006170;
								-webkit-box-shadow: 5px 7px 10px #cddadc;
								box-shadow: 5px 7px 10px #cddadc;
								color: #307f8b;
								background: #fff;
								margin-bottom: 10px;
							}
						}
					}
				}
			}

			&_panel {
				width: 100%;
				height: 80px;
				background: #F0F4F5;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				font-size: 18px;
				color: #000000;

				&_tabs {
					display: flex;
					width: 160px;
					height: 40px;
					justify-content: center;
					align-items: center;
					border-right: 1px solid #999999;

					span {
						border-right: 0px solid #999999;
						height: 40px;
						align-items: center;
						display: flex;
						width: 160px;
						justify-content: center;
					}

					&_next {
						color: #000000;
					}

					&_next:first-child {
						span {
							border-right: 1px solid #999999
						}
					}

					.next_active {
						color: #006170;
						font-weight: bold;
					}
				}

				&_tabs:last-child {
					border-right: 0px solid #999999;

					span {
						border-right: 0px solid #999999;
					}
				}

				.active {
					color: #666666;
					width: 100%;
					justify-content: flex-start;

					.span {
						border-right: 1px solid #999999;
					}
				}
			}
		}

		.count_info {
			.subject_count_newleft {
				width: 1140px !important;
			}

			display: flex;
			justify-content: space-between;

			.subject_count_left {
				width: 1400px;
				padding: 0;

				.info_tit {
					.tit_right {
						float: right;
						display: flex;
						align-items: center;

						&:hover {
							opacity: .8;
							cursor: piinter
						}

						.el-divider {
							background-color: #000000;
						}

						span {
							color: #000000;
							font-weight: 400;
							font-size: 16px;
						}
					}
				}
			}
		}

		.cont_l .more_btn {
			width: 320px;
			position: relative;
			overflow: hidden;
			height: 80px;
			font-size: 18px;
			text-align: center;
			line-height: 80px;
			color: #fff;
			background: #006170;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			margin-left: 40px;
		}

		.cont_l .more_btn span,
		.cont_l .more_btn img {
			position: relative;
			z-index: 9;
		}

		.cont_l .more_btn img {
			margin-left: 30px;
		}

		.cont_l .more_btn::after {
			content: '';
			width: 100%;
			height: 100%;
			background: #333333;
			display: block;
			position: absolute;
			top: 0;
			left: -100%;
			z-index: 8;
			transition: all 0.3s ease 0s;
			-webkit-transition: all 0.3s ease 0s;
			-moz-transition: all 0.3s ease 0s;
			-o-transition: all 0.3s ease 0s;
		}

		.cont_l .more_btn:hover::after {
			left: 0px;
			transition: all 0.3s ease 0s;
			-webkit-transition: all 0.3s ease 0s;
			-moz-transition: all 0.3s ease 0s;
			-o-transition: all 0.3s ease 0s;
		}

		.contact-way {
			background-color: #ffffff !important;
		}
	}

	.deputy_panel {
		width: 100%;
		height: 80px;
		background: #F0F4F5;
		display: flex;
		padding-left: 30px;
		margin-bottom: 20px;
		align-items: center;
		font-size: 18px;
		color: #000000;

		.tabs_active {
			flex: 8;
			height: 40px;
			display: flex;
			align-items: center;

			.tabs_next {
				height: 40px;
				display: flex;
				align-items: center;
				color: #666666;
				padding-right: 30px;
				border-right: 1px solid #999999;
			}

			.panel_tabs_next {
				padding: 0 37px;
			}

			.panel_tabs_next:hover {
				color: #006170;
				font-weight: bold;
				cursor: pointer;
			}

			.active {
				color: #006170;
				font-weight: bold;
			}
		}

		.deputy_panel_tabs {
			display: flex;
			width: 120px;
			flex-wrap: wrap;
			position: relative;
			height: 80px;
			align-items: center;
			margin: 0;
			padding: 0;
			justify-content: flex-end;

			.span {
				height: 40px;
				display: flex;
				align-items: center;
				width: 139px;
				justify-content: center;
				margin: 20px 0;
			}

			.deputy_panel_tabs_next {
				height: 0px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 139px;
				background: #333333;
				position: relative;
				z-index: 1;
				border-top: 1px solid #F0F4F5;
				color: #8C8C8C;
				opacity: 0;
			}

			.deputy_panel_tabs_next:last-child {
				border-bottom: 0px solid #F0F4F5;
			}

			&:hover {
				background: #333333;
				color: #FFFFFF;

				.deputy_panel_tabs_next {
					height: 80px;
					opacity: 1;
				}
			}
		}

		.deputy_panel_tabs {
			.next_active {
				background: #006170;
				color: #FFFFFF;
			}

			.deputy_panel_tabs_next:hover {
				background: #006170;
				color: #FFFFFF;
			}
		}

		.deputy_panel_tabs:nth-child(2) {
			.span {
				border-left: 1px solid #999999;
				border-right: 1px solid #999999;
			}
		}
	}

	.dsj_list_tit .time_list span:hover {
		color: #006170;
	}

	.dsj_list .xiangzuo:hover {
		opacity: 0.8;
	}

	.dsj_list {
		margin-top: 30px;

		.dsj_list_tit {
			display: flex;
			align-items: center;

			.time_list {
				background: #f0f4f5;
				padding: 0 30px;
				height: 60px;
				line-height: 60px;
				display: flex;

				span {
					display: block;
					width: 60px;
					text-align: center;
					margin-right: 30px;
					font-size: 16px;
					color: #666;
					cursor: pointer;
				}

				.tit_active {
					background: #006170;
					color: #fff;
					height: 65px;
					box-shadow: 8px 8px 8px #cddadc;
				}
			}

			img {
				width: 60px;
				height: 60px;
				cursor: pointer;
			}
		}

		.subj_content {
			.news-list {
				display: flex;
				flex-wrap: wrap;

				.cont {
					margin: 0 40px 40px 0;

					.info_up {
						background: #f3f3f3;
						padding: 40px;
						width: 320px;
						height: 412px;

						.title {
							line-height: 40px;
							height: 40px;
							text-align: center;
							overflow: hidden;
							cursor: pointer;
						}

						.pointer {
							width: 240px;
							height: 332px;
						}
					}
				}

				.cont:nth-child(4n) {
					margin: 0;
				}
			}
		}
	}

	/* 影视作品 GO*/
	.pro-container {
		margin-top: 40px;

		.row {
			margin: 0px;
		}

		.tit_right:hover {
			opacity: .8;
			cursor: pointer
		}

		a:hover {
			text-decoration: none;
		}

		.item {
			width: 320px;
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;
			float: left;
			margin: 0 0 30px 40px;
			cursor: pointer;

			&:nth-child(4n+1) {
				margin-left: 0px;
			}

			.photos {
				width: 100%;
				height: 320px;
				position: relative;

				.photo {
					width: 100%;
					object-fit: cover;
					height: 100%;
				}
			}

			.tit_left {
				float: left
			}

			.time {
				margin-top: 10px;
				color: #666666;
				font-size: 14px;
			}
		}

		.info_tit {
			margin-bottom: 37px;
			overflow: hidden;
		}

		.pointer_img:hover {
			transform: scale(1.2);
			overflow: hidden;
		}

		.f14 {
			span {
				color: #000000;
				font-size: 14px !important;
			}

			/deep/.el-divider {
				background-color: #000000 !important;
			}
		}
	}

	@media screen and (min-width: 899px) and (max-width: 1150px) {
		.yipinyun-dec .qrcode {
			width: 230px;
			overflow: hidden;
			float: right;
			margin-right: 44px;
		}
	}
</style>
